import BaseTable from "../BaseTable";
import RefreshScheduleModal from "@/Modals/CurrencyManagement/RefreshSchedules/Modal";
import { currencyRateRefreshSchedulesApi } from "@/apis/apis";
import { fxRateRefreshScheduleColumns } from "./FxRateRefreshScheduleColumns";

export default function FxRateRefreshScheduleTable() {
  return (
    <>
      <h1 className="mb-3 text-[24px] text-neutral-600">
        FX Rates Refresh Schedule
      </h1>
      <BaseTable
        label="Fx Rate Refresh Schedule"
        apiURL={currencyRateRefreshSchedulesApi}
        columns={fxRateRefreshScheduleColumns()}
        ModalComponent={RefreshScheduleModal}
        importData={null}
        enableExport={false}
        enableAdd={false}
        enableDelete={false}
        enableSearch={false}
        enableFilter={false}
        enablePagination={false}
        confirmationModalTitleKey={(item) => item.time}
      />
    </>
  );
}
